var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderSlot as _renderSlot, TransitionGroup as _TransitionGroup, Fragment as _Fragment } from "vue";
var _hoisted_1 = { class: "booking-widget__fields" };
var _hoisted_2 = { class: "booking-widget__controls" };
var _hoisted_3 = ["disabled"];
var _hoisted_4 = {
    key: 0,
    class: "loader loader--white"
};
var _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-airplane-depart icon--sm",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_6 = {
    key: 0,
    class: "booking-widget__promo-row"
};
var _hoisted_7 = { class: "booking-widget__promo-row__col1" };
var _hoisted_8 = ["href", "target", "title"];
var _hoisted_9 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-chevroncurve icon--xs icon-color--white" }, null, -1 /* HOISTED */);
var _hoisted_10 = {
    key: 1,
    class: "booking-widget__histogram"
};
import { ref, computed, watch, inject, provide } from 'vue';
import ItineraryFields from '../ItineraryFields/ItineraryFields.vue';
import IconPreloader from '../IconPreloader/IconPreloader.vue';
import { useElementSize } from '@vueuse/core';
import PromoCode from '../PromoCode/PromoCode.vue';
import HistogramRenderer from '../HistogramRenderer/HistogramRenderer.vue';
import createAmadeusBestPricesHistogramRequest from '../../lib/createAmadeusBestPricesHistogramRequest';
import optiClient from '../../services/api';
import useOptiContent from '../../hooks/useOptiContent';
import { getIsOpti } from '../../services/api/getBaseUrl';
import AmadeusFormSubmission from '../AmadeusFormSubmission/AmadeusFormSubmission.vue';
import useAmadeusParams from '../../hooks/useAmadeusParams';
import { useIsMobile } from '../../hooks/useIsMobile';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BookingWidget',
    props: {
        dataContentId: {},
        flightLandingPath: { default: '/en/flights/' },
        hasOverLay: {},
        promoCodeProp: { default: '' },
        prefillTripType: { default: 'return' },
        prefillCabinClass: {},
        prefillFromDate: {},
        prefillToDate: {},
        prefillOrigin: {},
        prefillDestination: {}
    },
    setup: function (__props) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        var props = __props;
        var defaultPassengerAndCabinClass = {
            adults: 1,
            cabin: 'economy',
            youth: 0,
            child: 0,
            infant: 0,
        };
        var isMobile = useIsMobile();
        var createPrefillItinerary = function (prefillOrigin, prefillDestination) {
            var itinerary = {};
            if (!prefillOrigin && !prefillDestination)
                return itinerary;
            if (prefillOrigin) {
                itinerary.fromAirport = prefillOrigin;
                itinerary.fromAirportCode = prefillOrigin.locIATA;
            }
            if (prefillDestination) {
                itinerary.toAirport = prefillDestination;
                itinerary.toAirportCode = prefillDestination.locIATA;
            }
            return itinerary;
        };
        var loading = ref(false);
        var itineraries = ref([
            __assign(__assign({}, createPrefillItinerary(props.prefillOrigin, props.prefillDestination)), { departureDate: (_a = props.prefillFromDate) !== null && _a !== void 0 ? _a : undefined }),
            __assign(__assign({}, createPrefillItinerary(props.prefillDestination, props.prefillOrigin)), { departureDate: (_b = props.prefillToDate) !== null && _b !== void 0 ? _b : undefined })
        ]);
        var apiPricesHistogram = ref();
        var passengerAndCabinClass = ref(__assign(__assign({}, defaultPassengerAndCabinClass), { cabin: (_c = props.prefillCabinClass) !== null && _c !== void 0 ? _c : defaultPassengerAndCabinClass.cabin }));
        var promoCode = ref(props.promoCodeProp ? props.promoCodeProp : '');
        var amadeusFareFamilies = (_d = inject('amadeus-fare-families')) !== null && _d !== void 0 ? _d : [
            'CFFECOBIZ',
            'CFFBIZ',
        ];
        var getTripTypeLabel = function (value) {
            switch (value) {
                case 'oneway':
                    return 'One way';
                case 'multi-city':
                    return 'Multi-city';
                default:
                    return 'Return';
            }
        };
        var tripType = ref({
            label: getTripTypeLabel(props.prefillTripType),
            value: props.prefillTripType
        });
        var data = useOptiContent(props.dataContentId).data;
        provide('cms-props', data);
        var defaultLabel = (_g = (_f = (_e = data.value) === null || _e === void 0 ? void 0 : _e.searchFlightsButtonLabel) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : 'Search flights';
        var el = ref();
        var isEditing = ref(false);
        var width = useElementSize(el).width;
        var size = computed(function () {
            if (width.value > 1080) {
                return 'large';
            }
            else if (width.value > 629) {
                return 'medium';
            }
            return 'small';
        });
        var pricesRequest = computed(function () {
            if (!itineraries.value[0].fromAirport || !itineraries.value[0].toAirport)
                return null;
            return createAmadeusBestPricesHistogramRequest({
                itineraries: itineraries.value,
                tripDuration: 7,
                durationFlexibility: 1,
                fareFamilies: amadeusFareFamilies,
            });
        });
        var isBookDisabled = computed(function () {
            return itineraries.value.some(function (itinerary) {
                return (!itinerary.fromAirport ||
                    !itinerary.toAirport ||
                    !itinerary.departureDate) &&
                    !itinerary.ignore;
            });
        });
        var getFlightPrices = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, optiClient.bookings.postApiV1BookingsFlightsSearch(pricesRequest.value)];
                    case 1:
                        res = _a.sent();
                        apiPricesHistogram.value = res;
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var params = useAmadeusParams({
            itinerariesRef: itineraries,
            promoCodeRef: promoCode,
            passengerAndCabinClassRef: passengerAndCabinClass,
        });
        var urlRenderer = function (itemData) {
            var _a, _b, _c, _d, _e, _f;
            var isOpti = getIsOpti();
            var from = (_a = itineraries.value[0].fromAirport) === null || _a === void 0 ? void 0 : _a.locIATA;
            var to = (_b = itineraries.value[0].toAirport) === null || _b === void 0 ? void 0 : _b.locIATA;
            var fromCity = ((_d = (_c = itineraries.value[0].fromAirport) === null || _c === void 0 ? void 0 : _c.locCity) !== null && _d !== void 0 ? _d : '')
                .toLowerCase()
                .replace(/\s/g, '-');
            var toCity = ((_f = (_e = itineraries.value[0].toAirport) === null || _e === void 0 ? void 0 : _e.locCity) !== null && _f !== void 0 ? _f : '')
                .toLowerCase()
                .replace(/\s/g, '-');
            var urlParams = new URLSearchParams();
            urlParams.append('month', itemData.date);
            if (from) {
                urlParams.append('from', from);
            }
            if (to) {
                urlParams.append('to', to);
            }
            var passengerAndCabinClassValue = passengerAndCabinClass.value;
            if (passengerAndCabinClassValue.adults !== defaultPassengerAndCabinClass.adults) {
                urlParams.append('adults', passengerAndCabinClassValue.adults.toString());
            }
            if (passengerAndCabinClassValue.youth !== defaultPassengerAndCabinClass.youth) {
                urlParams.append('youth', passengerAndCabinClassValue.youth.toString());
            }
            if (passengerAndCabinClassValue.child !== defaultPassengerAndCabinClass.child) {
                urlParams.append('child', passengerAndCabinClassValue.child.toString());
            }
            if (passengerAndCabinClassValue.infant !== defaultPassengerAndCabinClass.infant) {
                urlParams.append('infant', passengerAndCabinClassValue.infant.toString());
            }
            if (passengerAndCabinClassValue.cabin !== defaultPassengerAndCabinClass.cabin) {
                urlParams.append('cabin', passengerAndCabinClassValue.cabin);
            }
            if (isOpti) {
                return "".concat(props.flightLandingPath).concat(fromCity, "-to-").concat(toCity, "?").concat(urlParams.toString());
            }
            else {
                return "/iframe.html?id=components-flightlandingwidget--flight-landing-widget-component-in-header&viewMode=story&".concat(urlParams);
            }
        };
        watch([function () { return pricesRequest.value; }, function () { return itineraries.value; }], function (_a) {
            var newPricesRequest = _a[0], newItineraries = _a[1];
            if (newPricesRequest) {
                getFlightPrices();
            }
            if (tripType.value && tripType.value.value === 'multi-city') {
                for (var i = 1; i < newItineraries.length; i++) {
                    if (!newItineraries[i].fromAirport && newItineraries[i - 1].toAirport) {
                        newItineraries[i].fromAirport = newItineraries[i - 1].toAirport;
                    }
                }
            }
        }, { deep: true });
        var setIsEditing = function (value) {
            if (isMobile.value === true) {
                isEditing.value = false;
                window.removeEventListener('click', windowClickHandler);
                window.removeEventListener('scroll', windowScrollHandler);
                return;
            }
            isEditing.value = value;
            if (value === true) {
                window.addEventListener('click', windowClickHandler);
                window.addEventListener('scroll', windowScrollHandler);
            }
            else {
                window.removeEventListener('click', windowClickHandler);
                window.removeEventListener('scroll', windowScrollHandler);
            }
        };
        var windowClickHandler = function (e) {
            if (!e.target)
                return;
            var isInBookingWidget = e.target.closest('.booking-widget') !== null;
            var isInResults = e.target.closest('.airport-item') !== null;
            if (!isInBookingWidget && !isInResults) {
                setIsEditing(false);
            }
        };
        var windowScrollHandler = function () {
            if (!el.value) {
                return;
            }
            var rect = el.value.getBoundingClientRect();
            if (rect.bottom < 0) {
                setIsEditing(false);
            }
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(IconPreloader, {
                    icons: ['calendar', 'plus'],
                    storybook: false
                }),
                _createElementVNode("div", {
                    ref_key: "el",
                    ref: el,
                    class: _normalizeClass([
                        'booking-widget',
                        'booking-widget--' + size.value,
                        { isEditing: isEditing.value },
                    ]),
                    onClick: _cache[5] || (_cache[5] =
                        function () {
                            setIsEditing(true);
                        })
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(ItineraryFields, {
                            itineraries: itineraries.value,
                            "onUpdate:itineraries": _cache[0] || (_cache[0] = function ($event) { return ((itineraries).value = $event); }),
                            passengerAndCabinClass: passengerAndCabinClass.value,
                            "onUpdate:passengerAndCabinClass": _cache[1] || (_cache[1] = function ($event) { return ((passengerAndCabinClass).value = $event); }),
                            "trip-type": tripType.value,
                            "onUpdate:tripType": _cache[2] || (_cache[2] = function ($event) { return ((tripType).value = $event); }),
                            size: size.value
                        }, null, 8 /* PROPS */, ["itineraries", "passengerAndCabinClass", "trip-type", "size"]),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(AmadeusFormSubmission, {
                                refx: "",
                                params: _unref(params),
                                onOnSubmit: _cache[3] || (_cache[3] = function ($event) { return (loading.value = true); })
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("button", {
                                        class: _normalizeClass([
                                            'button--md',
                                            'button',
                                            'button--iconleft',
                                            'booking-widget__search-button',
                                            {
                                                'booking-widget__search-button--loading': loading.value,
                                            },
                                        ]),
                                        disabled: isBookDisabled.value,
                                        type: "submit"
                                    }, [
                                        (loading.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                                            : _createCommentVNode("v-if", true),
                                        _hoisted_5,
                                        _createTextVNode(" " + _toDisplayString(size.value === 'medium' ? _unref(defaultLabel).split(' ')[0] : _unref(defaultLabel)), 1 /* TEXT */)
                                    ], 10 /* CLASS, PROPS */, _hoisted_3)
                                ]; }),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["params"])
                        ])
                    ]),
                    _createVNode(_TransitionGroup, {
                        name: "slide-fade",
                        appear: ""
                    }, {
                        default: _withCtx(function () {
                            var _a, _b, _c, _d, _e;
                            return [
                                (itineraries.value[0].fromAirport && itineraries.value[0].toAirport)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createVNode(PromoCode, {
                                                inputValue: promoCode.value,
                                                "onUpdate:inputValue": _cache[4] || (_cache[4] = function ($event) { return ((promoCode).value = $event); })
                                            }, null, 8 /* PROPS */, ["inputValue"]),
                                            _renderSlot(_ctx.$slots, "visa-modal", { itineraries: itineraries.value })
                                        ]),
                                        _createElementVNode("p", null, [
                                            ((_a = _unref(data)) === null || _a === void 0 ? void 0 : _a.bookWithClId.value)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    href: (_b = _unref(data)) === null || _b === void 0 ? void 0 : _b.bookWithClId.value.href,
                                                    target: _unref(data).bookWithClId.value.target
                                                        ? _unref(data).bookWithClId.value.target
                                                        : undefined,
                                                    title: _unref(data).bookWithClId.value.title
                                                }, [
                                                    _createTextVNode(_toDisplayString((_c = _unref(data)) === null || _c === void 0 ? void 0 : _c.bookWithClId.value.text), 1 /* TEXT */),
                                                    _hoisted_9
                                                ], 8 /* PROPS */, _hoisted_8))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (((_d = apiPricesHistogram.value) === null || _d === void 0 ? void 0 : _d.data) && ((_e = tripType.value) === null || _e === void 0 ? void 0 : _e.value) === 'return')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createVNode(HistogramRenderer, {
                                            "api-prices": apiPricesHistogram.value,
                                            "url-renderer": urlRenderer
                                        }, {
                                            terms: _withCtx(function () { return [
                                                _renderSlot(_ctx.$slots, "terms")
                                            ]; }),
                                            _: 3 /* FORWARDED */
                                        }, 8 /* PROPS */, ["api-prices"])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ];
                        }),
                        _: 3 /* FORWARDED */
                    })
                ], 2 /* CLASS */)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
